import * as svg from "../../../assets/booking-icon.svg";

import {iconBuilder} from "./iconBuilder";

export const BookingIcon = iconBuilder(svg, "BookingIcon", "0 0 900 900");
